import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { inlineFlexbox, justifyContent, alignItems, flexbox } from '../../styles/helpers/flexbox';

const CheckboxContainer = styled.div`
    ${inlineFlexbox()};
    ${justifyContent('center')};
    ${alignItems('center')};
  `;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    border: 0;
    clip: rect(0 0 0 0);
    clippath: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`;

const CustomCheckbox = styled.div((props) => {
  const { palette } = ThemeHelper.getTheme(props);
  const { primary } = palette;
  const { currentState } = props;

  return `
    ${flexbox()};
    ${alignItems('center')};
    width: 16px;
    height: 16px;
    border-radius: 3px;
    transition: all 150ms;
    background: ${currentState === 'checked' ? '#00a5ff' : 'white'};
    border: 1px solid ${primary.light};
    cursor: pointer;

    svg {
      width: 100%;
      height: 100%;
    }

    ${HiddenCheckbox}:focus + & {
        box-shadow: 0 0 0 3px ${primary.light};
    }
  `;
});

const IconChecked = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 3px;
`;

const IconIntermediate = styled.svg`
  background: #00a5ff;
  fill: white;
  stroke: white;
`;

const IconDisabled = styled.svg((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
  background: ${colours.grey[200]};
  fill: ${colours.grey[200]};
  stroke: ${colours.grey[200]};
  cursor: default;
`;
});

const IconUnchecked = styled.svg`
  background: white;
`;

export {
  CheckboxContainer,
  HiddenCheckbox,
  CustomCheckbox,
  IconChecked,
  IconIntermediate,
  IconUnchecked,
  IconDisabled
};
